$(document).ready(async function () {
    
    $(document).on('currentSubscriptionAdded', function () {
        console.log(window.currentSubscription)
        if (window.currentSubscription && window.currentSubscription.product_title.includes('Every Order')) {
            console.log('wrokig2')
            $('#manage_subscriptions_upsells').hide();
        }
    })

    $(document).on('click', '.addProductAsSubscription', async function (e) {
        //prevent click event
        e.preventDefault();

        //Loading text
        $(this).val('Adding...');

        //Get the product details
        const productId = $(this).data('product-id');

        // Get Current Selected Subscription Id
        const currentSubscriptionId = extractSubscriptionId(window.location.href);

        //get curent subscription
        const currentSubscription = await recharge.subscription.getSubscription(sessionRecharge, currentSubscriptionId);

        //GetProductBunlde of current product
        if (currentSubscription.status === 'active') {
            //Get existing subscritption's product details
            const productDetails = await recharge.product.productSearch(sessionRecharge, {
                limit: 25,
                format_version: '2022-06',
                external_product_ids: [currentSubscription.external_product_id.ecommerce],
            });

            //Get Selected Varient Object
            const getSelectedVariantObject = productDetails.products[0].variants.find(
                (obj) => obj.title === currentSubscription.variant_title
            );
            console.log(productDetails);
            let prodHandle = productDetails.products[0].handle;
            if (prodHandle == "quiz-product") {
                prodHandle = "custom-food-therapy-meals"
            }
            //Get current product bundle if required
            const currentProductBundle = getObjectByHandle(
                prodHandle,
                window.bundleVariation.products
            );


            //Ger Desired budle Variation
            const getDesiredBundleVariation = getObjectByOptionValues(
                getSelectedVariantObject.option_values,
                currentProductBundle.variants
            );

            //Update the current product to bundle product
            const updateSubscriptionStatus = await recharge.subscription.updateSubscription(
                sessionRecharge,
                currentSubscriptionId,
                { external_variant_id: { ecommerce: getDesiredBundleVariation.external_variant_id } }
            );

            $(this).val('Added');
            window.location.reload();
        } else {
            // TODO
        }
    });
});

/**
 * Get product object by passing handle and array of products
 */
const getObjectByHandle = (handle, arrayOfObjects) => {
    // Find the object with the matching handle
    const foundObject = arrayOfObjects.find((obj) => obj.handle.includes(handle));

    return foundObject || null; // Return the found object or null if not found
};

/**
 * Extracts the subscription ID from a Shopify subscription portal URL.
 *
 * @param {string} url - The Shopify subscription portal URL.
 * @returns {string|null} - The extracted subscription ID or null if not found.
 */
const extractSubscriptionId = (url) => {
    // Use a regular expression to extract the subscription ID from the URL
    const match = url.match(/\/subscriptions\/(\d+)/);

    // Check if a match is found
    if (match && match[1]) {
        // Return the extracted subscription ID
        return match[1];
    }

    // Return null if no match is found
    return null;
};

/**
 * Get variation object by passing option_value array and array of products
 */
const getObjectByOptionValues = (optionValues, arrayOfObjects) => {
    // Find the object with matching option values
    const foundObject = arrayOfObjects.find((obj) => optionValues.every((value) => obj.option_values.includes(value)));

    return foundObject || null; // Return the found object or null if not found
};